import { useAuthContext } from "providers/Auth";
import { Layout } from "providers/Layout";
import { SdkIntegration } from "./components/SdkIntegration";
import { FEATURES, PropertyManagementSystem } from "types/landlord/partner";
import { ResmanIntegration } from "./components/ResmanIntegration";
import { useSettingsController } from "./controller";
import { BuildiumIntegration } from "./components/BuildiumIntegration";
import { YardiIntegration } from "./components/YardiIntegration";
import { RentManagerIntegration } from "./components/RentManagerIntegration";
import { RentersWarehouseIntegration } from "./components/RentersWarehouseIntegration";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { BoomScreenWebhooks } from "./slices/BoomScreenWebhooksSlice";
import { RentvineIntegration } from "./components/RentvineIntegration";
import { QuextIntegration } from "./components/QuextIntegration";
import { AppfolioIntegration } from "./components/AppfolioIntegration";
import { EntrataIntegration } from "./components/EntrataIntegration";
import { ManageAmericaIntegration } from "./components/ManageAmericaIntegration";

const PropertyManagementIntegration = ({
  propertyManagementSystem
}: {
  propertyManagementSystem?: PropertyManagementSystem | "";
}) => {
  switch (propertyManagementSystem) {
    case PropertyManagementSystem.RESMAN:
      return <ResmanIntegration />;
    case PropertyManagementSystem.BUILDIUM:
      return <BuildiumIntegration />;
    case PropertyManagementSystem.YARDI:
      return <YardiIntegration />;
    case PropertyManagementSystem.RENT_MANAGER:
      return <RentManagerIntegration />;
    case PropertyManagementSystem.RENTERS_WAREHOUSE:
      return <RentersWarehouseIntegration />;
    case PropertyManagementSystem.MANAGE_AMERICA:
      return <ManageAmericaIntegration />;
    case PropertyManagementSystem.RENTVINE:
      return <RentvineIntegration />;
    case PropertyManagementSystem.QUEXT:
      return <QuextIntegration />;
    case PropertyManagementSystem.APPFOLIO:
      return <AppfolioIntegration />;
    case PropertyManagementSystem.ENTRATA:
      return <EntrataIntegration />;
    default:
      return null;
  }
};

export const DevelopersView = () => {
  const { type, partner } = useAuthContext();
  const { propertyManagementSystem } = useSettingsController();

  return (
    <Layout
      header={
        <>
          <div className="flex items-center justify-between border-b border-alpha-40 px-3 md:px-6 pb-3">
            <BreadCrumbs
              crumbs={[
                {
                  title: "Settings",
                  href: "/settings"
                },
                {
                  title: "Developers",
                  href: "/settings/developers"
                }
              ]}
            />
          </div>
          <div className="flex items-center justify-between p-6 pb-3">
            <h1 className="text-xl font-bold text-content-1000">Developers</h1>
          </div>
        </>
      }
    >
      <div className="flex flex-col gap-y-6">
        <PropertyManagementIntegration
          propertyManagementSystem={propertyManagementSystem}
        />
        {type.isSDK || partner?.features.includes(FEATURES.API_ACCESS) ? (
          <SdkIntegration />
        ) : null}
        {type.isBoomScreen || type.isSDK ? <BoomScreenWebhooks /> : null}
      </div>
    </Layout>
  );
};
